var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongqueues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.34003V40.66L22.4 42.48C20.18 45 18.36 44.32 18.36 40.96V26.56H12.18C9.37999 26.56 8.59999 24.84 10.46 22.74L24 7.34003Z",
    fill: "#6B3BED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.54 25.26L24 40.66V7.33998L25.6 5.51998C27.82 2.99998 29.64 3.67998 29.64 7.03998V21.44H35.82C38.62 21.44 39.4 23.16 37.54 25.26Z",
    fill: "#6B3BED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongqueues);
export default __webpack_public_path__ + "static/media/longqueues.46268dc89705124fcac6fcaf72591ee7.svg";
export { ForwardRef as ReactComponent };